<script setup lang="ts">
const props = defineProps({
  modelValue: {
    type: Number,
    required: true,
  },
  maxCount: {
    type: Number,
    default: 10000,
  },
});

const emit = defineEmits(["update:modelValue"]);

const formValue = ref(props.modelValue);
const validationError = ref(false);

function validate(): boolean {
  if (formValue.value === 0) {
    validationError.value = true;
    return false;
  }

  emit("update:modelValue", formValue);
  return true;
}

defineExpose({ validate });
</script>

<template>
  <div>
    <div class="form-number-guests">
      <h3>Number of guests:</h3>
      <div>
        <FormsNumberStepper v-model="formValue" :max-count="maxCount" />
      </div>
    </div>
    <FormsFieldError v-if="validationError && formValue === 0" style="text-align: center">
      Please enter number of guests
    </FormsFieldError>
  </div>
</template>

<style lang="scss">
@use "@/assets/scss/queries";
div {
  .form-number-guests {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    justify-content: flex-start;
    margin-top: 3rem;

    h3 {
      margin-bottom: 0 !important;
    }

    @include queries.for-size(ipadpro-portrait-down) {
      align-items: center;
      flex-direction: column;
      gap: 2rem;
      padding-top: 3rem;

      h3 {
        margin: auto;
      }
    }

    @include queries.for-size(phone-only) {
      sub {
        font-size: 15px !important;
      }
    }
  }
}
</style>
